<template>
	<div class="readpage_body">
		<div class="kong_box" v-if="dataCode != 0">
			<img src="@comm/images/document-conversion/zxyl/kong_icon.png" />
			<p class="name">{{ dataCode == 1000 ? "文件分享链接已过期！" : "文件无法打开！" }}</p>
			<p class="sname" v-if="dataCode == 1000">
				作者设置的分享已过期，请联系
				<span>{{ nickname }}</span>重新分享
			</p>
		</div>
		<div v-else class="readpage_main">
			<div class="read_page" v-if="showType != 2">
				<!-- 轻阅读头部 -->
				<readpage-top
					:fileInfo="fileInfo"
					@printBth="printBth"
					status="shareReadPage"
				></readpage-top>
				<div class="reader">
					<!-- 轻阅读 -->
					<iframe id="web-reader" ref="iframe" :src="readerUrl" frameborder="0" allowfullscreen="true"></iframe>
				</div>
			</div>
			<div class="zip_body" v-else>
				<div class="zip_top">
					<div class="zippage_top">
						<div class="left">
							<span></span>
							<a :title="fileInfo.sName">{{ fileInfo.sName | limitFileName(20, true) }}</a>
						</div>
						<div class="right" @click="downBtn" :class="{ disable: fileInfo.permissionDownload == 1 }">
							<span></span>下载
						</div>
					</div>
				</div>
				<div class="zip_content">
					<div class="breadcrumb" v-if="navList.length > 0">
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item
								v-for="(item, index) in navList"
								:key="index"
								@click.native="clickNav(item)"
							>
								<a :title="item.name">{{ item.name | limitFileName(10, true) }}</a>
							</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
					<div class="scroll_box" v-if="zipList.length > 0">
					<ul>
						<li v-for="(item, index) in zipList" :key="index" @click="openTxt(item)">
							<img src="@comm/images/document-conversion/zxyl/txt_icon.png" v-if="item.resourceType == 0" />
							<img src="@comm/images/document-conversion/zxyl/zip_icon.png" v-if="item.resourceType == 1" />
							<img src="@comm/images/document-conversion/zxyl/ofd_icon.png" v-if="item.fileType == 'ofd'" />
							<img src="@comm/images/document-conversion/zxyl/pdf_icon.png" v-if="item.fileType == 'pdf'" />
							<img
								src="@comm/images/document-conversion/zxyl/word_icon.png"
								v-if="item.fileType == 'doc' || item.fileType == 'docx'"
							/>
							<img
								src="@comm/images/document-conversion/zxyl/excel_icon.png"
								v-if="item.fileType == 'xls' || item.fileType == 'xlsx'"
							/>
							<img
								src="@comm/images/document-conversion/zxyl/tiff_icon.png"
								v-if="item.fileType == 'tiff' || item.fileType == 'tif'"
							/>
							<img
								src="@comm/images/document-conversion/zxyl/ppt_icon.png"
								v-if="item.fileType == 'ppt' || item.fileType == 'pptx'"
							/>
							<img src="@comm/images/document-conversion/zxyl/wps_icon.png" v-if="item.fileType == 'wps'" />
							<img src="@comm/images/document-conversion/zxyl/txt1_icon.png" v-if="item.fileType == 'txt'" />
							<img
								src="@comm/images/document-conversion/zxyl/img_icon.png"
								v-if="item.fileType == 'jpg' || item.fileType == 'png' || item.fileType == 'bmp'"
							/>
							<img
								src="@comm/images/document-conversion/zxyl/error_img.png"
								v-if="
									item.fileType != 'ofd' &&
									item.fileType != 'pdf' &&
									item.fileType != 'doc' &&
									item.fileType != 'docx' &&
									item.fileType != 'xls' &&
									item.fileType != 'xlsx' &&
									item.fileType != 'tiff' &&
									item.fileType != 'tif' &&
									item.fileType != 'ppt' &&
									item.fileType != 'pptx' &&
									item.fileType != 'wps' &&
									item.fileType != 'txt' &&
									item.fileType != 'jpg' &&
									item.fileType != 'png' &&
									item.fileType != 'bmp' &&
									item.resourceType != 0 &&
									item.resourceType != 1
								"
							/>
							<a
								:title="item.fileName"
							>{{ item.fileName | limitFileName(item.fileType ? 4 : 5, !item.fileType) }}</a>
						</li>
					</ul>
					</div>
					<!-- 空文件 -->
					<p v-else class="empty">此文件夹为空。</p>
				</div>
			</div>
		</div>
		<pressDialog
			:modalShow.sync="showPressDialog"
			@getResult="getResult"
			:status="showErrTip"
			@closeModal="closeModal"
			:loading="loading"
		/>
	</div>
</template>

<script>
import { Base64 } from "js-base64";
import common from "@comm/utils/common";
import QRCode from "qrcodejs2";
import { saveAs } from "file-saver";
import { shareInfo, getShortUrlPoll, downloadqyd, queryByDirId, eventCount } from "@comm/api/document-conversion";
import { getUserInfo, setToken, setUserInfo } from "@comm/utils/auth";
import { getParam, getfilesize, copyText } from "@comm/utils/tools";
import pressDialog from "@comm/components/document-conversion/pressDialog";
import readpageTop from "@comm/components/document-conversion/readpageTop";
import { getWpsUserInfo } from "@comm/api/public-user/user";
export default {
	components: { pressDialog, readpageTop },
	name: "readPage",
	data() {
		return {
			isPhone: false,
			readerUrl: "",
			interval: null,
			fileInfo: {},
			shareUrl: "",
			iframeWin: "",
			dataCode: 0,
			showType: 0,
			zipList: [],
			password: "",
			showPressDialog: false,
			filePasswId: "",
			showErrTip: false, //解压失败 1 需要密码 2密码错误,
			// showKong: false,
			navList: [],
			loading: false,
			code: null,
			userInfo: null,
			path: '',
			nickname: ''
		};
	},
	beforeCreate() {
		this.isPhone = localStorage.getItem("isPhone");
		if (this.isPhone === 'true') {
			document.querySelector('body').setAttribute('style', 'min-width:auto;overflow: hidden;')
		}

	},
	beforeDestroy() {
		if (this.isPhone === 'true') {
			document.body.removeAttribute('style')
		}
	},
	created() {
		this.isPhone = localStorage.getItem("isPhone");
		let that = this;
		this.path = this.$route.path;
		this.userInfo = getUserInfo() ? JSON.parse(getUserInfo()) : null;
		this.code = this.$route.query.code ? this.$route.query.code : null;
		let indexs = ''
		if (!this.code) {
			indexs = this.path.lastIndexOf("&&");
			let nickname = this.path.substring(indexs + 2, this.path.length);
			this.nickname = decodeURIComponent(decodeURIComponent(nickname))
			localStorage.setItem('nickname',this.nickname)
		}
		if (this.code && !this.userInfo) {
			this.getUserInfoWps();
		} else {
			let path = this.$route.params.url;
            if (path) {
                var index = path.lastIndexOf(":");
				let currentIndex = !this.code?indexs-2:path.length
                this.shortUrl = path.substring(index + 1, currentIndex);
                setTimeout(function () {
                    that.getInfo(that.shortUrl);
                }, 1000);
            }
		}
	},
	mounted() { },
	beforeDestroy() { },
	watch: {},
	methods: {
		// joinBtn() {
		// 	window.open("https://jq.qq.com/?_wv=1027&k=buqIcKXH");
		// },
		// handleMessage(event) {
		// 	// 根据上面制定的结构来解析iframe内部发回来的数据
		// 	const data = event.data;
		// },
		getUserInfoWps() {
			getWpsUserInfo({
				code: this.code
			}).then((res) => {
				if (res.code === 100016) {
					this.$router.push({
						path: this.$route.path
					});
				} else {
					if (!this.userInfo) {
						let path = this.$route.params.url;
						if (path) {
							var index = path.lastIndexOf(":");
							this.shortUrl = path.substring(index + 1, path.length);
							this.getInfo(this.shortUrl);
						}
					}

					this.userInfo = res.data;
					setToken(this.userInfo.token);
					setUserInfo(JSON.stringify(this.userInfo));
				}
			});
		},
		getInfo(shortUrl) {
			let that = this;
			shareInfo(shortUrl)
				.then((res) => {
					if (res.data.code == 0) {
						this.getPoll(res.data.data);
					}
					this.dataCode = res.data.code;
					this.nickname=localStorage.nickname
				})
				.catch((err) => {
					// if (err.response.status == 401) {
					// 	setTimeout(function () {
					// 		setToken(token)
					// 		that.getInfo(shortUrl);
					// 	}, 1000);
					// }
				});
		},
		getPoll(data) {
			getShortUrlPoll(data)
				.then((res) => {
					let that = this;
					if (res.data.status == 1) {
						clearInterval(this.interval);
						this.interval = setInterval(function () {
							setTimeout(() => {
								that.getPoll(data);
							}, 0);
						}, 3000);
					} else {
						clearInterval(this.interval);
						this.fileInfo = res.data.fileInfo;
						document.title = this.fileInfo.fileName;
						let sName = this.fileInfo.fileName;
						let nameLength = sName.lastIndexOf(".");
						this.fileInfo.sName = sName.substring(0, nameLength);
						this.fileInfo.fileType = this.fileInfo.fileType ? this.fileInfo.fileType.toLowerCase() : null;
						this.fileInfo.fileSize = this.fileInfo.fileSize ? getfilesize(this.fileInfo.fileSize) : "0M";
						this.showType = res.data.showType;
						if (this.showType != 2) {
							eventCount({
								eventId: 1002,
								userId: this.userInfo.suwellUserId,
								fileId: this.fileInfo.fileId
							}).then((res) => {

							})
							let flag = ['jpg', 'png', 'bmp', 'ppt', 'pptx', 'tiff', 'tif'].includes(this.fileInfo.fileType)
							let permissionCopy = this.fileInfo.permissionCopy != 1 || !this.fileInfo.permissionCopy ? 1 : 0;
							if (flag) permissionCopy = 0
							let fileUrl = Base64.encode(this.fileInfo.fileName + "|" + this.fileInfo.fileUrl + "|" + permissionCopy);
							fileUrl = encodeURIComponent(fileUrl);
							let webUrl = localStorage.getItem("webUrl") ? localStorage.getItem("webUrl") : common.baseurl;
							const concatURL = encodeURIComponent(`${common.apiUrl}/pubservice/file/info?ticket=${data}`);
							if (this.fileInfo.permissionCopy != 1 || !this.fileInfo.permissionCopy) {
								// this.readerUrl = `${webUrl}?file=${fileUrl}${flag ? '' : '&viewMode=mix'}&type=onlinePreview`;
								this.readerUrl = `${webUrl}?file=${concatURL}${flag ? '' : '&viewMode=mix'}&type=onlinePreview`;
							} else {
								// this.readerUrl = `${webUrl}?file=${fileUrl}&type=onlinePreview`;
								this.readerUrl = `${webUrl}?file=${concatURL}&type=onlinePreview`;
							}
						} else {
							this.getList(this.fileInfo.fileId);
						}
					}
				})
				.catch(() => {
					clearInterval(this.interval);
				});
		},
		downBtn() {
			if (this.fileInfo.permissionDownload == 1 || this.fileInfo.expiredType == -1) {
				return;
			}
			downloadqyd(this.fileInfo.fileId).then((res) => {
				if (!res) {
					Message.error("下载文件失败");
					return false;
				}
				let filename = this.fileInfo.fileName;
				const blob = new Blob([res.data]);
				if (sessionStorage.getItem("browserType") == "IE") {
					saveAs(blob, filename);
				} else {
					const downloadElement = document.createElement("a");
					const href = window.URL.createObjectURL(blob); // 创建下载的链接
					downloadElement.href = href;
					downloadElement.download = decodeURIComponent(filename);
					// downloadElement.download = file.file.filename
					document.body.appendChild(downloadElement);
					downloadElement.click(); // 点击下载
					document.body.removeChild(downloadElement); // 下载完成移除元素
					window.URL.revokeObjectURL(href); // 释放blob对象
				}
			})
				.catch((err) => {
					if (err.code == "ECONNABORTED" && err.message.indexOf("timeout") != -1) {
						this.$alert("网络不佳或内容过大", "提示", {
							confirmButtonText: "确定"
						});
					}
				});
		},
		// 打印
		printBth() {
			if (this.fileInfo.permissionPrint == 1 || this.fileInfo.expiredType == -1) {
				return;
			}
			this.$refs.iframe.contentWindow.postMessage(["click", "print"], "*");
		},
		closeModal() {
			this.showErrTip = false;
			this.showPressDialog = false;
		},
		getList(id, pasw) {
			queryByDirId({
				dirId: id,
				password: pasw ? pasw : ""
			}).then((res) => {
				this.loading = false;
				if (res.data.code == 5003) {
					this.showPressDialog = true;
					this.filePasswId = id;
				} else if (res.data.code == 5004) {
					this.showErrTip = true;
				} else {
					this.showErrTip = false;
					this.showPressDialog = false;
					let navListName, navListId;
					if (res.data.pathNameList) {
						navListName = res.data.pathNameList.reverse();
					}
					if (res.data.pathList) {
						navListId = res.data.pathList.reverse();
					}
					this.navList = [];
					navListName.forEach((item, index) => {
						let nav = {};
						nav.name = item;
						this.navList.push(nav);
					});
					navListId.forEach((item, index) => {
						this.navList[index].id = item;
					});
					if (res.data.child.length > 0) {
						res.data.child.forEach((item) => {
							item.fileType = item.fileType ? item.fileType.toLowerCase() : null;
						});
					}
					this.zipList = res.data.child;
					eventCount({
						eventId: 1002,
						userId: this.userInfo.suwellUserId,
						fileId: id
					}).then((res) => {

					})
				}
			});
		},
		openTxt(item) {
			if (item.isAllowedPreview == 0) {
				this.$message.error("该格式暂不支持预览");
				return;
			} else if (item.isAllowedPreview == 1) {
				this.$message.error("文件大小为空不支持预览");
				return;
			}
			if (item.resourceType == 2) {
				let nickname =encodeURIComponent(encodeURIComponent(this.nickname))
				const { href } = this.$router.resolve({
					path: `/s:${item.shareUrl}&&${nickname}`
				});
				window.open(href, "_blank");
			} else {
				this.getList(item.fileId);
			}
		},
		getResult(data) {
			this.loading = true;
			this.getList(this.filePasswId, data);
		},
		clickNav(item) {
			this.getList(item.id);
		}
	}
};
</script>
<style lang="scss">
.share_box {
	.el-dialog__body {
		padding: 8px 24px !important;
	}
}
.zip_body {
	.el-breadcrumb__inner {
		color: #383e45 !important;
		font-weight: normal !important;
		cursor: pointer !important;
	}
	.el-breadcrumb__inner a,
	.el-breadcrumb__inner.is-link {
		font-weight: normal !important;
		cursor: pointer;
	}
	.el-breadcrumb__item:last-child .el-breadcrumb__inner,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
		font-weight: normal !important;
		cursor: pointer;
	}
	.el-breadcrumb__separator {
		color: #383e45;
	}
}
</style>
<style lang="scss" scoped>
.share_box {
	.dialog-title {
		font-size: 16px;
		font-family: MicrosoftYaHei;
		color: #36425a;
		line-height: 21px;
		span {
			font-size: 12px;
			font-family: MicrosoftYaHei;
			color: #666666;
			line-height: 16px;
			margin-left: 18px;
		}
	}
	.content {
		font-size: 12px;
		color: #36425a;
		line-height: 16px;
		.qx {
			margin-bottom: 16px;
		}
		p {
			span {
				margin-left: 8px;
				strong {
					color: #14a8f0;
					font-weight: normal;
				}
				&.shareUrl {
					margin-left: 4px;
					width: 296px;
					height: 30px;
					line-height: 30px;
					padding: 0 8px;
					background: #ffffff;
					border: 1px solid #dadada;
					display: inline-block;
				}
			}
			&.shareUrl_box {
				margin: 32px 0 52px;
			}
		}
		ul {
			display: flex;
			align-items: center;
			margin-bottom: 32px;
			li {
				margin-right: 56px;
				span {
					display: inline-block;
					width: 16px;
					height: 16px;
					margin-right: 2px;
					vertical-align: middle;
					background: url("../../comm/images/document-conversion/zxyl/dg_icon.png")
						0 0 no-repeat;
					background-size: 100%;
				}
			}
		}
	}
}
.readpage_body {
    position: relative;
	background: #ffffff;
	height: 100%;
	overflow-y: hidden;
	.read_page {
		height: 100%;
		display: flex;
		flex-direction: column;
	}
	.reader {
		flex: 1;
		height: auto;
	}
	.kong_box {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;
		img {
			width: 286px;
			height: 210px;
		}
		.name {
			font-size: 18px;
			color: #14a8f0;
			line-height: 24px;
			margin: 17px 0 8px;
		}
		.sname {
			font-size: 12px;
			color: #b1b1b1;
			line-height: 16px;
			span{
				color: #64CCFF;
			}
		}
	}
}
.readpage_main {
	height: 100%;
}
.zip_body {
	background: #ffffff;
	height: 100%;
	.zippage_top {
		height: 44px;
		background: #f5f5f5;
		padding: 0 15px 0 10px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.left {
			font-size: 14px;
			color: #000000;
			span {
				display: inline-block;
				width: 32px;
				height: 32px;
				background: url("../../comm/images/document-conversion/zxyl/icon_zip.png")
					0 0 no-repeat;
				background-size: 100%;
				margin-right: 6px;
				vertical-align: middle;
			}
		}
		.right {
			font-size: 12px;
			color: #333333;
			&.disable,
			&.disable:hover {
				opacity: 0.5;
				cursor: default;
			}
			&:hover {
				cursor: pointer;
			}
			span {
				display: inline-block;
				width: 24px;
				height: 24px;
				background: url("../../comm/images/document-conversion/zxyl/down_btn.png")
					0 0 no-repeat;
				background-size: 100%;
				margin-right: 5px;
				vertical-align: middle;
			}
		}
	}
	.zip_content {
		        height: 100%;
    display: flex;
    flex-direction: column;
    .scroll_box{
          overflow: auto;
    height: 100%;
    }
		.breadcrumb {
			margin: 16px 22px 0;
			font-size: 14px;
			font-weight: 400;
			color: #383e45;
			line-height: 20px;
			padding: 0 0 8px;
			border-bottom: 1px solid #d8dce5;
			background: none;
			word-wrap: none;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		ul {
			padding: 0 10px;
			display: flex;
			flex-direction: row;
			align-items: center;
			flex-wrap: wrap;
			li {
				width: 116px;
				height: 136px;
				display: flex;
				flex-direction: column;
				align-items: center;
				margin: 16px 12px;
				&:hover {
					background: #f8f8f8;
				}
				img {
					width: 50px;
					height: 50px;
					margin: 18px auto;
				}
				a {
					width: 102px;
					height: 24px;
					font-size: 12px;
					color: #36425a;
					line-height: 24px;
					margin: 3px auto 20px;
					text-align: center;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					word-wrap: none;
				}
			}
		}
		.empty {
			text-align: center;
			margin-top: 16px;
			font-size: 14px;
			color: #b1b1b1;
		}
	}
	.kong_box {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;
		img {
			width: 286px;
			height: 210px;
		}
		.name {
			font-size: 18px;
			color: #14a8f0;
			line-height: 24px;
			margin: 17px 0 8px;
		}
		.sname {
			font-size: 12px;
			color: #b1b1b1;
			line-height: 16px;
			span {
				color: #64ccff;
			}
		}
	}
}
</style>




// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/shareReadPage.vue